import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params, callback) => {
    return AppModel.get('category_all_list_for_sub', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.get('categoryList', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      if (!modelStore) {
        modelStore = {}
      }
      modelStore['categoryList'] = res.data
      store.commit('setModel', modelStore)

      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('categoryList', key)
  },
  removeStore: () => {
    delete store.getters.model.categoryList
  }
}



// WEBPACK FOOTER //
// ./src/models/CategoryListForSub.js